import state from './moduleVoucherState.js';
import mutations from './moduleVoucherMutations.js';
import actions from './moduleVoucherActions.js';
import getters from './moduleVoucherGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
